<template>
  <doughnut title="Tariffs" :apiData="latest" />
</template>

<script>
import { mapActions, mapState } from 'vuex'

import Doughnut from '@/components/Doughnut'

export default {
  name: 'UsersTariffsLatest',
  components: {
    Doughnut,
  },
  methods: {
    ...mapActions('users/tariffs', ['getLatest']),
  },
  computed: {
    ...mapState('users/tariffs', ['latest']),
  },
  async created() {
    this.getLatest()
  },
}
</script>
